const RoadFreight = () => {
  return (
    <div>
        
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="px-1 flex flex-col justify-center">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Overland Freight
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                This is the preferred choice of a large customer base when it comes to secure, economical and time-definite 
                transportation of bulk and heavy cargo shipments to cross-border regional territories.
              </p>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                As the only logistics operations in Pakistan with TIR (Transports Internationaux Routiers) licence, 
                we are at the forefront of driving multi-modal regional connectivity, and empowering regional trade, 
                CPEC and Pakistan’s role in the OBOR initiative.
              </p>
             
          </div>
          <div className="flex-1 flex flex-col justify-center items-center lg:mt-[0rem] mt-[1rem]">
            <img src="/international-freight/Road-Freight-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>

      </div>

    </div>
  );
};
  
export default RoadFreight;
  